import React, { Component } from 'react';
import Typical from 'react-typical';
import Switch from 'react-switch';

class Header extends Component {
  titles = [];

  constructor() {
    super();
    this.state = { checked: false };
    this.onThemeSwitchChange = this.onThemeSwitchChange.bind(this);
  }

  onThemeSwitchChange(checked) {
    this.setState({ checked });
    this.setTheme();
  }

  setTheme() {
    var dataThemeAttribute = 'data-theme';
    var body = document.body;
    var newTheme =
      body.getAttribute(dataThemeAttribute) === 'dark' ? 'light' : 'dark';
    body.setAttribute(dataThemeAttribute, newTheme);
  }

  render() {
    if (this.props.sharedData) {
      var name = this.props.sharedData.name;
      this.titles = this.props.sharedData.titles.map((x) => [x, 1500]).flat();
    }

    const HeaderTitleTypeAnimation = React.memo(
      () => {
        return (
          <Typical className='title-styles' steps={this.titles} loop={50} />
        );
      },
      (props, prevProp) => true
    );

    const links = this.props.sharedData ? this.props.sharedData.social || [] : [];
    const tagline =
      this.props.resumeBasicInfo && this.props.resumeBasicInfo.tagline
        ? this.props.resumeBasicInfo.tagline
        : '';

    return (
      <header id='home'>
        <div className='header-inner'>
          <h1 className='mb-0'>
            <Typical steps={[name]} wrapper='p' />
          </h1>
          <div className='title-container'>
            <HeaderTitleTypeAnimation />
          </div>
          {tagline ? <p className='header-tagline'>{tagline}</p> : null}
          <div className='header-actions'>
            {links.map((l) => (
              <a
                key={l.name}
                href={l.url}
                className='header-action'
                target={l.url.indexOf('mailto:') === 0 ? '_self' : '_blank'}
                rel='noopener noreferrer'
              >
                <i className={l.class}></i>
                <span>{l.name === 'Linkedin' ? 'LinkedIn' : l.name}</span>
              </a>
            ))}
          </div>
          <Switch
            checked={this.state.checked}
            onChange={this.onThemeSwitchChange}
            offColor='#baaa80'
            onColor='#353535'
            className='react-switch mx-auto'
            width={62}
            height={28}
            uncheckedIcon={
              <span
                className='iconify'
                data-icon='twemoji:owl'
                data-inline='false'
                style={{
                  display: 'block',
                  height: '100%',
                  fontSize: 17,
                  textAlign: 'end',
                  marginLeft: '12px',
                  color: '#353239',
                }}
              ></span>
            }
            checkedIcon={
              <span
                className='iconify'
                data-icon='noto-v1:sun-with-face'
                data-inline='false'
                style={{
                  display: 'block',
                  height: '100%',
                  fontSize: 17,
                  textAlign: 'end',
                  marginLeft: '7px',
                  color: '#353239',
                }}
              ></span>
            }
            id='icon-switch'
          />
          <a className='header-scroll-cue' href='#about' aria-label='Scroll to about'>
            <span></span>
          </a>
        </div>
      </header>
    );
  }
}

export default Header;
